import React, { useEffect, useState } from 'react'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { customBannersColumns } from 'helpers/custom-banners-columns'
import { GenericDataTable } from 'helpers/generic-data-table'
import {
  fetchCustomBanners,
  deleteBanner,
} from 'store/customBanners/customBannersSlice'
import { useAppDispatch, useAppSelector } from 'store/store'
import CustomBannerForm from 'ui/components/CustomBannerForm'

const CustomBannersPage: React.FC = () => {
  const dispatch = useAppDispatch()
  const { totalPages, banners } = useAppSelector((state) => state.customBanners)
  const [pageIndex, setPageIndex] = useState(0)
  const pageSize = 20

  useEffect(() => {
    dispatch(fetchCustomBanners(pageIndex + 1)) // Initial page load
  }, [dispatch, pageIndex])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              Custom Banners
            </h2>
            <p className='text-muted-foreground'>
              Custom banner inseriti da backoffice
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <GenericDataTable
            columns={customBannersColumns({
              onDeleteBanner: (bannerId) => {
                dispatch(deleteBanner(bannerId))
              },
            })}
            data={banners || []}
            pageCount={totalPages}
            pageIndex={pageIndex}
            pageSize={pageSize}
            onPageIndexChange={setPageIndex}
            toolbar={<CustomBannerForm />}
          />
        </div>
      </Main>
    </>
  )
}

export default CustomBannersPage
